import { UntitledModalWrapper } from "@repo/ui/index.tsx";
import useRoutesHandler from "@/Hooks/useRouteHandler";
import SelectTypeComponent from "./SelectTypeComponent";
import { useState } from "react";
import SelectSegment from "./SelectSegment";
const QuickProductCreationModal = ({
  isOpen,
  toggler,
}: {
  isOpen: boolean;
  toggler: () => void;
}) => {
  //States
  const [step, setStep] = useState<number>(1);
  const { navigateBackTo } = useRoutesHandler();

  //Functions
  const handleCloseModal = () => {
    navigateBackTo({ searchKey: ["type", "segment"] });
    toggler();
  };

  return (
    <UntitledModalWrapper
      isOpen={isOpen}
      handleCloseModal={handleCloseModal}
    >
      <div className="w-[750px]">
        {step === 1 ? (
          <SelectTypeComponent setStep={setStep} />
        ) : (
          <SelectSegment
            handleCloseModal={handleCloseModal}
            setStep={setStep}
          />
        )}
      </div>
    </UntitledModalWrapper>
  );
};

export default QuickProductCreationModal;
